import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../interfaces/base";
import {
  IGetWorkoutPayload,
  IWorkoutState,
  ICreateWorkoutPayload,
  IUpdateWorkoutPayload,
  IDeleteWorkoutPayload,
} from "../../../interfaces/store/workout-interface";
import { ICreateWorkoutInProgramPayload } from "../../../interfaces/store/training-program-interface";

const initialState: IWorkoutState = {
  workout: null,
  error: null,
  loading: false,
  requestState: "prepare",
  operation: null,
  trainingPrograms: [],
};

const _getWorkoutStart = (
  state: IWorkoutState,
  { payload }: PayloadAction<IGetWorkoutPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getWorkoutSuccess = (
  state: IWorkoutState,
  { payload }: PayloadAction<any>
) => {
  state.workout = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getWorkoutFailed = (
  state: IWorkoutState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetWorkout = (state: IWorkoutState) => {
  state.workout = null;
  state.error = null;
  state.loading = false;
  state.requestState = "prepare";
  state.operation = null;
  state.trainingPrograms = [];
};

const _createWorkoutStart = (
  state: IWorkoutState,
  {
    payload,
  }: PayloadAction<ICreateWorkoutPayload | ICreateWorkoutInProgramPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "create";
};

const _createWorkoutSuccess = (
  state: IWorkoutState,
  { payload }: PayloadAction<any>
) => {
  state.workout = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
  state.operation = "create";
};

const _createWorkoutFailed = (
  state: IWorkoutState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.workout = null;
  state.requestState = "error";
};

const _updateWorkoutStart = (
  state: IWorkoutState,
  { payload }: PayloadAction<IUpdateWorkoutPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "update";
};

const _updateWorkoutSuccess = (
  state: IWorkoutState,
  { payload }: PayloadAction<any>
) => {
  state.workout = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
  state.operation = "update";
};

const _updateWorkoutFailed = (
  state: IWorkoutState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  // state.workout = null;
  state.requestState = "error";
};

const _deleteWorkoutStart = (
  state: IWorkoutState,
  { payload }: PayloadAction<IDeleteWorkoutPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "delete";
};

const _deleteWorkoutSuccess = (
  state: IWorkoutState,
  { payload }: PayloadAction<any>
) => {
  state.workout = null;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _deleteWorkoutFailed = (
  state: IWorkoutState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.workout = null;
  state.requestState = "error";
};

const _fetchTrainingProgramsForWorkoutStart = (
  state: IWorkoutState,
  { payload }: PayloadAction<any>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _fetchTrainingProgramsForWorkoutSuccess = (
  state: IWorkoutState,
  { payload }: PayloadAction<any>
) => {
  state.trainingPrograms = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchTrainingProgramsForWorkoutFailed = (
  state: IWorkoutState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const WorkoutSlice = createSlice({
  name: "workout",
  initialState,
  reducers: {
    getWorkoutStart: _getWorkoutStart,
    getWorkoutSuccess: _getWorkoutSuccess,
    getWorkoutFailed: _getWorkoutFailed,
    resetWorkout: _resetWorkout,
    createWorkoutStart: _createWorkoutStart,
    createWorkoutSuccess: _createWorkoutSuccess,
    createWorkoutFailed: _createWorkoutFailed,
    updateWorkoutStart: _updateWorkoutStart,
    updateWorkoutSuccess: _updateWorkoutSuccess,
    updateWorkoutFailed: _updateWorkoutFailed,
    deleteWorkoutStart: _deleteWorkoutStart,
    deleteWorkoutSuccess: _deleteWorkoutSuccess,
    deleteWorkoutFailed: _deleteWorkoutFailed,
    createWorkoutInProgramStart: _createWorkoutStart,
    updateWorkoutInProgramStart: _updateWorkoutStart,
    fetchTrainingProgramsForWorkoutStart: _fetchTrainingProgramsForWorkoutStart,
    fetchTrainingProgramsForWorkoutSuccess:
      _fetchTrainingProgramsForWorkoutSuccess,
    fetchTrainingProgramsForWorkoutFailed:
      _fetchTrainingProgramsForWorkoutFailed,
  },
});

export const {
  getWorkoutStart,
  getWorkoutSuccess,
  getWorkoutFailed,
  resetWorkout,
  createWorkoutStart,
  createWorkoutSuccess,
  createWorkoutFailed,
  updateWorkoutStart,
  updateWorkoutSuccess,
  updateWorkoutFailed,
  deleteWorkoutStart,
  deleteWorkoutSuccess,
  deleteWorkoutFailed,
  createWorkoutInProgramStart,
  updateWorkoutInProgramStart,
  fetchTrainingProgramsForWorkoutStart,
  fetchTrainingProgramsForWorkoutSuccess,
  fetchTrainingProgramsForWorkoutFailed,
} = WorkoutSlice.actions;
export default WorkoutSlice.reducer;
